export type AuthGateState = 'loading' | 'unavailable' | 'reconnecting' | 'unauthenticated' | 'ok';

/**
 * `sessionVerified` means /users/me (or a login) succeeded on this page.
 * Such a session stays mounted when a later request cannot reach the backend
 * ('reconnecting'): swapping the page for the retry card would unmount the
 * editor mid-edit over a single failed request. A session restored only from
 * the local cache has never been confirmed, so it still gets the retry card.
 */
export function resolveAuthGate({
  isLoading,
  user,
  isBackendUnavailable,
  sessionVerified,
}: {
  isLoading: boolean;
  user: unknown | null;
  isBackendUnavailable: boolean;
  sessionVerified: boolean;
}): AuthGateState {
  if (isLoading) return 'loading';
  if (isBackendUnavailable) return sessionVerified && user ? 'reconnecting' : 'unavailable';
  if (!user) return 'unauthenticated';
  return 'ok';
}
